<template>
  <el-col v-if="buttonList != null && buttonList.length > 0" :span="24" class="toolbar" style="padding-bottom: 0px;">
    <el-form :inline="true" @submit.native.prevent>
      <el-form-item>
        <el-select style="width: 180px;" @change="selectBusLinesIdChanged" v-model="busLinesId" clearable
          placeholder="请选择公交线路">
          <el-option v-for="item in busLinesList" :key="item.Id" :value="item.Id" :label="item.LineChineseName">
            <span style="float: left">{{ item.LineChineseName }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select style="width: 180px;" v-model="schedulingTemplateId" clearable placeholder="请选择发车模版">
          <el-option v-for="item in schedulingTemplateList" :key="item.Id" :value="item.Id"
            :label="item.DepartureTemplate">
            <span style="float: left">{{ item.DepartureTemplate }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select style="width: 180px;" v-model="startSite" clearable placeholder="请选择开始站点">
          <el-option v-for="item in startSiteList" :key="item.Id" :value="item.SiteChineseName"
            :label="item.SiteChineseName">
            <span style="float: left">{{ item.SiteChineseName }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select style="width: 180px;" @change="selectClassNameChanged" v-model="className" clearable
          placeholder="请选择班别名称">
          <el-option v-for="item in classNameList" :key="item.Id" :value="item.Id" :label="item.DictName">
            <span style="float: left">{{ item.DictName }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select style="width: 180px;" v-model="shiftName" clearable placeholder="请选择班次名称">
          <el-option v-for="item in shiftNameList" :key="item.Id" :value="item.DictName" :label="item.DictName">
            <span style="float: left">{{ item.DictName }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <!-- 这里触发点击事件 -->
        <el-button
          :type="item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'"
          v-if="!item.IsHide" @click="callFunc(item)">{{ item.name }}</el-button>
      </el-form-item>
    </el-form>
  </el-col>
</template>
<script>
import { getBusLinesListPage, getBusLineDirectionByBusLinesId, getDictionaryListPageByDictNameAndDictCode, getDictionaryListPageByPid, getSchedulingTemplateListPage } from "../../api/api";

export default {
  name: "ShiftToolbar",
  data() {
    return {
      busLinesList: [], //线路列表
      startSiteList: [], //开始站点列表
      classNameList: [], //班别列表
      shiftNameList: [], //班次列表
      schedulingTemplateList: [], //排班模版列表
      busLinesId: "", //线路ID
      schedulingTemplateId: "", //排班模版表Id
      startSite: "", //开始站点
      className: "", //班别名称
      shiftName: "" //班次名称
    };
  },
  props: ["buttonList"], //接受父组件传值
  methods: {
    callFunc(item) {
      item.busLinesId = this.busLinesId;
      item.schedulingTemplateId = this.schedulingTemplateId;
      item.startSite = this.startSite;
      item.className = this.className;
      item.shiftName = this.shiftName;
      this.$emit("callFunction", item); //将值传给父组件
    },
    selectBusLinesIdChanged(value) {
      this.startSiteList = [];
      this.startSite = "";
      this.schedulingTemplateList = [];
      this.schedulingTemplateId = "";
      if (value !== "") {
        this.getStartSiteList();
        this.getSchedulingTemplateList();
      }
    },
    getStartSiteList() {
      let para = {
        busLinesId: this.busLinesId
      };
      getBusLineDirectionByBusLinesId(para).then(res => {
        this.startSiteList = res.data.data;
      });
    },
    selectClassNameChanged(value) {
      this.shiftNameList = [];
      this.shiftName = "";
      if (value !== "") {
        var obj = {};
        obj = this.classNameList.find(function (item) {
          return item.Id === value;
        });
        this.className = obj.DictName;
        this.getShiftNameList(value);
      }
    },
    getShiftNameList(id) {
      let para = {
        Pid: id,
        pageSize: 100
      };
      getDictionaryListPageByPid(para).then(res => {
        this.shiftNameList = res.data.data;
      });
    },
    getSchedulingTemplateList() {
      let para = {
        busLinesId: this.busLinesId,
        pageSize: 20
      };
      getSchedulingTemplateListPage(para).then(res => {
        this.schedulingTemplateList = res.data.response.data;
      });
    },
  },
  mounted() {
    let pageSizePara = {
      pageSize: 100
    };
    getBusLinesListPage(pageSizePara).then(res => {
      this.busLinesList = res.data.response.data;
    });
    let para = {
      dictName: '班别',
      dictCode: 'Class',
      pageSize: 100
    };
    getDictionaryListPageByDictNameAndDictCode(para).then(res => {
      this.classNameList = res.data.data;
    });
    this.getSchedulingTemplateList();
  }
};
</script>